// extracted by mini-css-extract-plugin
export default {"fallback":"errorFallback_fallback__cZUmz","fallbackText":"errorFallback_fallbackText__SGo81"};